import Select, { SingleValue } from "react-select"

interface MyCustomSelectProps<TValue> {
    title: string,
    options : MyCustomSelectOptions<TValue>[],
    selectedValue: TValue,
    onChange: (value: TValue | null) => void
}

export interface MyCustomSelectOptions<TValue> {
    label: string,
    value: TValue
}

const ReactSelect = <T,>( props: MyCustomSelectProps<T> ) => {

    let {title, options, selectedValue, onChange} = props;

    const onInternalChange = (option: SingleValue<MyCustomSelectOptions<T>>) => {
        !!option ? onChange(option.value) : onChange(null)
    }

    const getSelectedOption = (selectedValue: T) => {
        return options.filter(it => it.value === selectedValue)
    }

    return (
    <>
        <label>{title}</label>
        <Select
            className={`w-100`}
            classNamePrefix={`select`}
            options={options}
            onChange={onInternalChange}
            value={getSelectedOption(selectedValue)}
            isClearable={!!selectedValue}
        />
    </>
    )
}

export default ReactSelect